import React from 'react';
import { Container, CircularProgress } from '@material-ui/core';
export function FullPageSpinner() {
  return (
    <Container className="circular-progressbar-container">
      <CircularProgress />
    </Container>
  );
}
